var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { RobberyBreakableElement } from '@shared/types/api/claim';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import BreakInDamagePicturesSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamagePicturesSection.vue';
const breakInDamage = namespace('breakInDamage');
const claim = namespace('claim');
const settings = namespace('settings');
const qualification = namespace('qualification');
let Photos = class Photos extends Vue {
    constructor() {
        super(...arguments);
        this.showValidation = false;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get requiredPhotos() {
        if (!this.setting) {
            return 0;
        }
        const trigram = this.trigram;
        if (!trigram) {
            return 0;
        }
        const directKey = `damageRequiredPhotosCount${trigram}`;
        let rawValue = null;
        try {
            rawValue = this.setting(directKey);
        }
        catch (_a) {
            rawValue = null;
        }
        if (rawValue === undefined || rawValue === null) {
            try {
                const groupedSetting = this.setting('damageRequiredPhotosCount');
                if (groupedSetting && typeof groupedSetting === 'object') {
                    rawValue = groupedSetting[trigram];
                }
            }
            catch (_b) {
                rawValue = null;
            }
        }
        const settingValue = Number(rawValue);
        return isNaN(settingValue) ? 0 : settingValue;
    }
    get hasEnoughPhotos() {
        var _a;
        const collection = this.breakInDamage.pictureCollection;
        const uploadedFiles = (_a = collection === null || collection === void 0 ? void 0 : collection.uploadedAppFiles) !== null && _a !== void 0 ? _a : [];
        return uploadedFiles.length >= this.requiredPhotos;
    }
    get isValid() {
        if (this.requiredPhotos === 0) {
            return true;
        }
        const hasNoViolation = !this.validation.fieldHasViolations('pictureCollection');
        const valid = hasNoViolation && this.hasEnoughPhotos;
        return valid;
    }
    save() {
        this.$emit('goToNextStep');
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
    get subtitleText() {
        const type = this.breakInDamage.type;
        if (!type)
            return null;
        const map = {
            [RobberyBreakableElement.Door]: 'door',
            [RobberyBreakableElement.Window]: 'window',
            [RobberyBreakableElement.Fence]: 'fence',
            [RobberyBreakableElement.FrenchWindow]: 'french-window',
            [RobberyBreakableElement.SlidingBayWindow]: 'sliding-bay',
            [RobberyBreakableElement.Shutter]: 'shutter',
            [RobberyBreakableElement.GarageDoor]: 'garage-door',
            [RobberyBreakableElement.Gate]: 'gate',
            [RobberyBreakableElement.Other]: 'other',
            [RobberyBreakableElement.LittleGate]: 'little-gate',
        };
        const key = map[type];
        return key ? this.$tc(`claim.declaration.break_in_damages.form.${key}.photos.subtitle`) : null;
    }
};
__decorate([
    breakInDamage.Getter('change')
], Photos.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Getter('validation')
], Photos.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], Photos.prototype, "validateBreakInDamage", void 0);
__decorate([
    settings.Getter('setting')
], Photos.prototype, "setting", void 0);
__decorate([
    claim.State('claim')
], Photos.prototype, "claim", void 0);
__decorate([
    qualification.Getter('typeTrigram')
], Photos.prototype, "trigram", void 0);
__decorate([
    Watch('claim', { deep: true })
], Photos.prototype, "change", null);
Photos = __decorate([
    Component({
        components: {
            BreakInDamageDescriptionStep,
            BreakInDamagePicturesSection,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
            isSaving: { type: Boolean, default: false },
        },
    })
], Photos);
export default Photos;
